export const setEmailErrorByReason = (reasons = [] as string[]): string => {
  let error = '';
  const reason = reasons[0];
  error = `common:registration.validation-errors.${reason}`;

  if (!error) {
    error = 'common:registration.validation-errors.unhandled';
  }
  return error;
};
